import { useState, useEffect, useContext } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';

const useTotalPrice = () => {
  const [dataState] = useContext(dataStore);
  const [appState] = useContext(appStore);
  const [totalPrice, setTotalPrice] = useState(0);

  const sizeId = appState.customData.bottle.size;

  useEffect(() => {
    const otherPrices = appState.customData.partsList.map((item) => {
      return item.price ? Number(item.price) : 0;
    });
    // ボトル以外のパーツの合計値
    const totalOptions = otherPrices.reduce((sum, element) => sum + element, 0);
    // 底ラバーがある場合、底ラバーの価格を追加
    let bootPrice = 0
    if (appState.customData.bootsList)  {
      bootPrice = Number(appState.customData.bootsList[0].variants[sizeId].price);
    }
    // ボトルを足して合計金額を算出
    const totalPrice = Number(appState.customData.bottle.price) + totalOptions + bootPrice;
    setTotalPrice(totalPrice);
  }, [appState.customData, dataState]);

  return [totalPrice];
};

export default useTotalPrice;
